//存健康数据的全部数据列表
import { GET_ALL_DATA, INIT_ALL_DATA, DELETE_DATA } from "./actionType";

const defaultState = {
  data: [],
  page: 0,
  onBottom: false,
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_ALL_DATA://存
      const newState = action.allData;
      const data = (state.data).concat (newState.data);
      newState.data = data;
      return { ...state, ...newState };

    case INIT_ALL_DATA://初始化出数据
      return { ...state, ...action.allData };

    case DELETE_DATA://删除
      const group = [...action.params.list];
      const oldState = { ...state };
      const newData = deleteData (oldState.data, group);
      oldState.data = newData;
      return oldState;

    default:
      return state;
  }
};

//删除数据
const deleteData = (a, group) => {
  const array = [...a];
  group.forEach (i => {
    const index = array.findIndex (v => v.uuid === i);
    array.splice (index, 1);
  });
  return array;
};

export default Reducer;
